var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_Upload",
    "data-name": "icon Upload",
    d: "M10.285,2.056a.751.751,0,0,0-.8.147l-.019.018L5.442,6.247A.75.75,0,0,0,6.5,7.308L9.25,4.561v7.856a.75.75,0,0,0,1.5,0V4.561L13.5,7.308a.75.75,0,1,0,1.061-1.061L10.53,2.22A.747.747,0,0,0,10.285,2.056ZM2.75,11.667a.75.75,0,0,1,.75.75v3.222a.861.861,0,0,0,.861.861H15.639a.861.861,0,0,0,.861-.861V12.417a.75.75,0,0,1,1.5,0v3.222A2.361,2.361,0,0,1,15.639,18H4.361A2.361,2.361,0,0,1,2,15.639V12.417A.75.75,0,0,1,2.75,11.667Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e36030668f7bd5654b69a0df8465406b.svg";
export { ForwardRef as ReactComponent };